var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEventUpcoming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.38086 8.96402V3.22117C2.38086 2.71599 2.58154 2.23151 2.93875 1.8743C3.29596 1.51709 3.78045 1.31641 4.28562 1.31641H4.29515L15.7237 1.37164C16.2272 1.37416 16.7093 1.57595 17.0644 1.93289C17.4196 2.28983 17.619 2.77288 17.619 3.27641V14.705C17.619 15.2102 17.4183 15.6946 17.0611 16.0518C16.7039 16.4091 16.2194 16.6097 15.7142 16.6097H15.7047L4.2761 16.5555C3.77258 16.5529 3.29053 16.3511 2.93538 15.9942C2.58022 15.6373 2.38085 15.1542 2.38086 14.6507V12.8097M2.38086 5.19069H17.619",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0944 13.7612L10.9515 10.904M10.9515 10.904L8.0944 8.04688M10.9515 10.904H1.42773",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventUpcoming);
export default __webpack_public_path__ + "static/media/event_upcoming.447a29fe38bfef50a2b47d15827560bf.svg";
export { ForwardRef as ReactComponent };